var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 8,
    fill: "#0060AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4985_42727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3037 19.2926C40.5771 18.4026 42.139 16.5598 42.139 14.4312C42.139 11.4321 39.0403 9.0011 35.2195 9.0011C35.0594 9.0011 34.9009 9.00566 34.7435 9.01423H31.5371C34.0443 10.0322 35.7574 12.086 35.7574 14.4535C35.7574 16.4021 34.5968 18.138 32.7876 19.2595C35.0755 20.4752 36.5822 22.5318 36.5822 24.861C36.5822 27.5807 34.5365 29.9248 31.5868 30.9988H34.9405V30.9942C35.0348 30.9942 35.1297 30.9988 35.2245 30.9988C39.5213 30.9988 43.0034 28.266 43.0034 24.8954C42.9995 22.3861 41.0659 20.2295 38.3037 19.2926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7161 24.897C35.7161 22.386 33.7826 20.2288 31.0203 19.292C33.2937 18.402 34.8556 16.5592 34.8556 14.4306C34.8556 11.4315 31.7569 9.00049 27.9362 9.00049C27.7766 9.00049 27.6175 9.00507 27.4607 9.01364H17V31.0005H27.6532V30.9959C27.7475 30.9959 27.8424 31.0005 27.9373 31.0005C32.2335 31.0005 35.7161 28.2677 35.7161 24.897ZM23.5378 13.9665L25.0517 13.9636C26.2794 13.9636 27.2715 14.7433 27.2715 15.7053C27.2715 16.6467 26.3201 17.4132 25.1304 17.4458H23.5378V13.9665ZM25.6901 25.7001H23.5378V21.9996L25.6064 21.9968C26.9099 21.9968 27.9663 22.8256 27.9663 23.8482C27.9663 24.8502 26.9546 25.6653 25.6901 25.7001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4985_42727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 22,
    fill: "white",
    transform: "translate(17 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasis);
export default __webpack_public_path__ + "static/media/basis.d871cb98368055ebdc8353d974705d48.svg";
export { ForwardRef as ReactComponent };